.activityItem {
  .activityLabel {
    position: relative;
    flex-shrink: 0;
    flex-grow: 0;
    margin-right: 10px;
    &::before {
      content: '';
      position: absolute;
      right: -24px;
      width: 4px;
      top: 0;
      bottom: -14px;
      background-color: var(--bs-primary-bg-subtle);
    }
  }
  .activityBadge {
    z-index: 1;
    line-height: 0;
    border-radius: 50%;
    flex-shrink: 0;
    flex-grow: 0;
  }
  .activityContent {
    padding-left: 10px;
    padding-bottom: 10px;
  }
  &:first-child {
    .activityLabel {
      &::before {
        top: 5px;
      }
    }
  }
  &:last-child {
    .activityContent {
      padding-bottom: 0;
    }
  }
  .eventBadge {
    z-index: 1;
    line-height: 0;
    border-radius: 50%;
    flex-shrink: 0;
    flex-grow: 0;
    margin: 6px;
    color: #6f6f6f;
    width: 3px;
  }
}

.activiyMentionImg {
  width: 35px !important;
  height: 35px !important;
  border-radius: 50%;
}

/* Target the container that you apply the custom class to */
.flatEditorContainer {
  border: var(--bs-border-width) solid var(--bs-border-color) !important;
  border-radius: var(--bs-border-radius) !important;

  :global(.tox-editor-header) {
    border-radius: 0 !important;
  }

  :global(.tox-edit-area) {
    border-radius: 0 !important;
  }

  :global(.tox-statusbar) {
    border-radius: 0 !important;
  }

  .activeEditor {
    &:before {
      border: var(--bs-border-width) solid !important;
      border-color: color-mix(in srgb, var(--bs-primary), white 50%) !important;
      border-radius: var(--bs-border-radius) !important;
      transition:
        border-color 0.15s ease-in-out,
        box-shadow 0.15s ease-in-out;
    }
  }
}
